import {React,useState} from 'react';
import './css/App.css';
import { collection, query, getDocs } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from './Firebase';
import shirts from "./images/shirts-image1.png"
import pants from "./images/pants-image1.png"
import shoses from "./images/register-image.png"
import { Header } from './Components/Header';

function App() {
  
  const [tops_img_file,settops_img_file] = useState(shirts);
  const [bottoms_img_file,setbottoms_img_file] = useState(pants);
  const [shoes_img_file,setshoes_img_file] = useState(shoses);

  const getwearinfo = async () =>{
    const auth = getAuth();
    const usera = auth.currentUser;
    const q = query(collection(db, "users"));
    const querySnapshot = await getDocs(q);
    // console.log(usera)
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        querySnapshot.forEach((doc) => {
          const tops_len = doc.data().tops_img_file.length;
          const bottoms_len = doc.data().bottoms_img_file.length;
          const shoes_len = doc.data().shoes_img_file.length;
          const test = Math.floor(Math.random() * tops_len);
          const test1 = Math.floor(Math.random() * bottoms_len);
          const test2 = Math.floor(Math.random() * shoes_len);
          console.log("test",test)
          console.log("test1",test1)
          console.log("test2",test2)
          // if(doc.id==usera.uid){
            console.log(doc.id, " => ", doc.data().tops_img_file);
            console.log(doc.id, " => ", doc.data().bottoms_img_file);
            console.log(doc.id, " => ", doc.data().shoes_img_file);
            settops_img_file(doc.data().tops_img_file[test])
            setbottoms_img_file(doc.data().bottoms_img_file[test1])
            setshoes_img_file(doc.data().shoes_img_file[test2])
          // }
        });
      } else {
        alert("ログインしてください");
      }
    })
  }
  
  return (
    <div className="homepage-login">
      <Header/>
      <div className="body">
        <div className="roulette-image1">
          <p><img src={tops_img_file}/></p>
        </div>
        <div className="roulette-image2">
          <p><img src={bottoms_img_file}/></p>
        </div>
        <div className="roulette-image3">
          <p><img src={shoes_img_file}/></p>
        </div>
        <div className="button">
        <button className="roulette-button" onClick={getwearinfo}>start</button>
        </div>
      </div>
      
    </div>
  );
}


export default App;
